module.exports = __webpack_public_path__ + "img/p1.a661f5c0.png";